export const AbstractIconDefaultProps = {
};

export const AbstractIconPropTypes = {
};

